import parseNavigation from './parseNavigation';

/** Menú del rol productor: `tipo id | título | ícono | url`, anidado por tabulación. */
const producerNavigation = parseNavigation(`
group producer-certificates | Certificados | account_tree
	item producer-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/producer/avaibles
	item producer-certificate-nominees | Certificados nominados | person_pin | /certificates/producer/nominees
	item producer-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item producer-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group producer-consults | Consultas | account_tree
	item producer-received-transfer-info | Certificados recibidos | move_to_inbox | /producer/consult/received-transfer-info
	item producer-transfer | Certificados disponibles | check_circle_outline | /producer/consult/transfer
	item producer-send-transfer-info | Certificados transferidos | send | /producer/consult/send-transfer-info
	item producer-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item producer-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
`);

export default producerNavigation;
